import { motion } from "framer-motion";
import { Mail, Phone, Instagram, BadgeCheck, MapPin } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};
const item = {
  hidden: { opacity: 0, y: 22 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="mx-auto max-w-3xl px-6 pt-16 pb-10 sm:pt-20 sm:pb-12"
    >
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
        className="relative overflow-hidden rounded-[1.75rem] border border-[#ececec] bg-white shadow-[0_40px_90px_-40px_rgba(44,168,160,0.4)]"
        data-testid="contact-card"
      >
        <div className="h-1.5 w-full bg-[#2ca8a0]" />
        <div className="p-8 sm:p-12">
          <motion.div variants={item} className="flex items-center gap-2">
            <BadgeCheck className="h-4 w-4 text-[#2ca8a0]" />
            <span className="eyebrow">Verified Contact</span>
          </motion.div>

          <motion.h2
            variants={item}
            className="font-display mt-5 text-3xl font-bold tracking-tight text-[#1a1a1a] sm:text-4xl"
          >
            Reach us directly.
          </motion.h2>
          <motion.p
            variants={item}
            className="font-body mt-4 max-w-md text-base leading-relaxed text-[#4a4a4a] sm:text-lg"
          >
            These are the only official channels for Azzaro Resorts &amp; Spa.
          </motion.p>

          <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2">
            <motion.a
              variants={item}
              href="mailto:info@azzarodiu.com"
              data-testid="contact-email"
              className="group flex items-center gap-4 rounded-2xl border border-[#ececec] bg-[#f7f6f2] p-5 transition-[transform,border-color,background-color] duration-500 hover:-translate-y-1 hover:border-[#2ca8a0]/50 hover:bg-white"
            >
              <span className="flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-[#2ca8a0] text-white transition-transform duration-500 group-hover:scale-105">
                <Mail className="h-5 w-5" />
              </span>
              <span className="min-w-0">
                <span className="block text-xs font-semibold uppercase tracking-[0.18em] text-[#5f5f5f]">
                  Email
                </span>
                <span className="font-display block truncate text-lg font-semibold text-[#1a1a1a]">
                  info@azzarodiu.com
                </span>
              </span>
            </motion.a>

            <motion.a
              variants={item}
              href="tel:+917201000746"
              data-testid="contact-phone"
              className="group flex items-center gap-4 rounded-2xl border border-[#ececec] bg-[#f7f6f2] p-5 transition-[transform,border-color,background-color] duration-500 hover:-translate-y-1 hover:border-[#2ca8a0]/50 hover:bg-white"
            >
              <span className="flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-[#2ca8a0] text-white transition-transform duration-500 group-hover:scale-105">
                <Phone className="h-5 w-5" />
              </span>
              <span className="min-w-0">
                <span className="block text-xs font-semibold uppercase tracking-[0.18em] text-[#5f5f5f]">
                  Phone
                </span>
                <span className="font-display block truncate text-lg font-semibold text-[#1a1a1a]">
                  +91 720 1000 746
                </span>
              </span>
            </motion.a>
          </div>

          <motion.a
            variants={item}
            href="https://maps.app.goo.gl/AqhDnZAsQNennAxv8"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-directions"
            className="group mt-4 flex items-center justify-center gap-3 rounded-2xl bg-[#157c74] p-5 text-white transition-[transform,background-color] duration-500 hover:-translate-y-1 hover:bg-[#0e5f58]"
          >
            <MapPin className="h-5 w-5 transition-transform duration-500 group-hover:scale-110" />
            <span className="font-display text-base font-semibold tracking-wide">
              Get Directions
            </span>
          </motion.a>

          <motion.div variants={item} className="mt-8 flex items-center gap-4">
            <div className="h-px flex-1 bg-[#ececec]" />
            <a
              href="https://www.instagram.com/azzaroresorts/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram"
              className="group inline-flex items-center gap-2 text-sm font-semibold text-[#333333]"
            >
              <Instagram className="h-4 w-4 text-[#2ca8a0] transition-transform duration-500 group-hover:scale-110" />
              <span className="link-underline pb-0.5">@azzaroresorts</span>
            </a>
            <div className="h-px flex-1 bg-[#ececec]" />
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;
